export const Separator = () => <div style={{
  width: '100%',
  height: 1,
  marginLeft: 10,
  marginTop: 10,
  marginBottom: 10,
  backgroundImage: 'linear-gradient(to right, white 50%, rgba(255, 255, 255, 0.4) 50%)'
}}
                               />
